<script setup lang="ts">
/**
 * UI-kit component
 * Category: Other
 * Name: RowInfo
 */
import type { RowInfoProps } from '../types/interfaces'

import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { LinkTextPrimary } from '@shared/ui/links'
import { BtnIcon } from '@shared/ui/buttons'

import { IconContainer } from '../../icon-container'
import { useRowInfo } from '../composables/use-row-info.hook'

defineOptions({
  name: 'RowInfo',
})

const props = withDefaults(defineProps<RowInfoProps>(), {
  title: '',
  value: '',
  target: '_self',
  color: 'blue',
  linkUrl: null,
  isCopyShow: false,
})

const {
  refIsCopied,
  setCopy,
} = useRowInfo(props)
</script>

<template>
  <div class="row-info">
    <AppText
      name="body1"
      class="row-info__label"
      color="slate-500"
    >
      {{ title }}
    </AppText>
    <slot v-if="$slots.default" />
    <template v-else>
      <AppText
        v-if="!linkUrl"
        name="body1"
        class="row-info__value"
        :title="value"
      >
        {{ value }}
      </AppText>
      <LinkTextPrimary
        v-else
        :href="linkUrl"
        :target="target"
        :color="color"
      >
        <IconContainer v-if="$slots.iconLeft">
          <slot name="iconLeft" />
        </IconContainer>
        {{ value }}
        <IconContainer v-if="$slots.iconRight">
          <slot name="iconRight" />
        </IconContainer>
      </LinkTextPrimary>
    </template>
    <BtnIcon
      v-if="isCopyShow && (linkUrl || value)"
      :icon="refIsCopied ? faCheck : faCopy"
      view="transparent"
      size="small"
      class="row-info__copy"
      @click="setCopy"
    />
  </div>
</template>

<style lang="scss" scoped src="../styles/_row-info.scss" />
